import { toast } from 'react-toastify';
import { messages } from '../../../utils/errorMessages'
/**
 * @param {error} object
 */
export const errorMessage = (error) => {
    let message; //passing common message for other status code in toaster

    if ("Network Error" === error.message) {
        message = messages.INTERNAL_SERVER_ERROR
    } else {
        const { status, data } = error.response;
        //passing response returned from status 404 as postcode are unavailable as entered in postcode input field
        message = status === 404 ? data.message : messages.ERROR
    }
    toast.error(message);
};
